export default "__VITE_ASSET__d26b3aef__"